<template>
  <div>
    <!-- 絞り込み解除 -->
    <el-button plain class="glance-cancel-down" size="small" @click="onClick" :disabled="disabled">
      <slot></slot>
    </el-button>
  </div>
</template>
<script>
export default {
  props:{
    disabled:Boolean
  },
  methods: {
    onClick(event) {
      if (this.$listeners.click) {
        this.$listeners.click()
        event.stopPropagation();
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.glance-cancel-down {
  border: 0px;
  text-align: center;
  font-size: 13px;
  padding: 0;
  color: #329CA6;
}

::v-deep .el-button:hover, .el-button:focus {
  background-color: transparent;
}
::v-deep .el-button {
  background-color: transparent;
    &:hover {
      background-color: transparent;
  }
   &.is-plain:hover {
    background-color: transparent;
    &.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
      background-image: none;
      background-color: #fff;
      border-color: #ebeef5;
    }
  }
}
::v-deep .el-button.is-plain:hover, .el-button.is-plain:focus {
  background-color: transparent;
}
</style>
